export default "__VITE_ASSET__DEZ9PR7e__"